export function hexToRgba(hex: string, alpha = 1): string {
  // Remove o '#' se estiver presente
  hex = hex.replace('#', '');

  // Converte o hexadecimal para RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Garante que o alfa esteja no intervalo [0, 1]
  alpha = Math.max(0, Math.min(1, alpha));

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
